import axios from "axios";
import {getBackendApiBaseUrl} from "./axios";

const STORAGE_NAME = 'userData';

/**
 * Данные авторизации хранятся в localStorage (см. hooks/auth.hook.js).
 * Читаем их безопасно: до логина или после logout там пусто.
 */
export const getStoredAuth = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_NAME)) || {};
    } catch (e) {
        console.error('Auth read error: ' + e);
        return {};
    }
};

const queryApi = axios.create({
    baseURL: getBackendApiBaseUrl(),
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

/* Токен подставляется на каждый запрос — компонентам больше не нужно
   собирать headers руками и прокидывать auth в пропсах. */
queryApi.interceptors.request.use(
    (config) => {
        const {token} = getStoredAuth();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

queryApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem(STORAGE_NAME);
            if (window.location.pathname !== '/') {
                window.location.replace('/');
            }
        }
        return Promise.reject(error);
    }
);

export default Object.assign(queryApi, {
    isCancel: axios.isCancel,
    CancelToken: axios.CancelToken
});
